import React from "react";
import { Link } from "react-router-dom";

const ShipmentRow = ({
  item,
  index,
  startIndex,
  loadingId,
  checkStatus,
}) => {
  return (
    <tr>
      <td>{startIndex + index + 1}</td>

      <td>
        <a
          href={item.trackingUrl}
          className="text text-primary"
          target="_blank"
          rel="noreferrer"
        >
          {item.awb}
        </a>
      </td>

      <td>
        <div className="fs-sm">
          Courier Name: {item.courierName}
        </div>

        <div className="fs-sm fw-medium">
          Provider: {item.providerName}
        </div>
      </td>

      <td>
        <b>
          {item.shippingCost.currency}{" "}
          {item.shippingCost.totalCharge}
        </b>
      </td>

      <td>
        <span
          className={`badge ${
            item.status === "Delivered"
              ? "badge-success"
              : item.status === "Cancelled"
              ? "badge-danger"
              : "badge-warning"
          }`}
        >
          {item.status}
        </span>
      </td>

      <td>
        <Link
          to={`/customer/details/${item.orderId?.userId?._id}`}
        >
          {item.orderId?.userId?.firstName || "-"}{" "}
          {item.orderId?.userId?.lastName || ""}
        </Link>
      </td>

      <td>
        {item.orderId?.phone && (
          <div className="fs-sm">
            <a href={`tel:${item.orderId.phone}`}>
              +91-{item.orderId.phone}
            </a>
          </div>
        )}

        {item.orderId?.email && (
          <div className="fs-sm">
            <a href={`mailto:${item.orderId.email}`}>
              {item.orderId.email}
            </a>
          </div>
        )}
      </td>

      <td>
        {item.status !== "Delivered" &&
          item.status !== "Cancelled" && (
            <button
              className="btn btn-success btn-sm me-2"
              onClick={() => checkStatus(item._id)}
              disabled={loadingId === item._id}
            >
              {loadingId === item._id ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-1"
                    role="status"
                  />
                  Refreshing...
                </>
              ) : (
                "Refresh"
              )}
            </button>
          )}

        <Link
          to={`/orders/details/${item.orderId.orderId}`}
          className="btn btn-primary btn-sm"
        >
          View
        </Link>
      </td>
    </tr>
  );
};

export default React.memo(ShipmentRow);